export { default } from './PageTouristAgencies.vue'
